/**
 * Clinio support contact used in staff UI.
 *
 * Email comes from the help-article seed (`support@clinio.dk` in
 * `supabase/seeds/help_articles_seed.sql`). No Clinio support phone exists
 * in this repo (only third-party numbers such as Sygeforsikring Danmark).
 */
export const CLINIO_SUPPORT_EMAIL = 'support@clinio.dk';

export function clinioSupportMailto(): string {
  return `mailto:${CLINIO_SUPPORT_EMAIL}`;
}
